import { useEffect, useRef } from 'react';

import ErrorTracking from 'Lib/errorTracking';
import useRequestIdleCallback from 'Hooks/useRequestIdleCallback';

const useErrorTracking = () => {
  const errorTracker = useRef<ErrorTracking>();

  useEffect(() => {
    if (!errorTracker.current) {
      errorTracker.current = new ErrorTracking();
    }

    return () => {
      if (errorTracker.current) {
        errorTracker.current.destroy();
      }
    };
  }, []);

  useRequestIdleCallback(errorTracker.current?.init);

  return errorTracker.current;
};

export default useErrorTracking;
